export default function getRandomElements(array, count) {
  const copy = [...array];
  // Shuffle the copied array
  const shuffled = copy.sort(() => 0.5 - Math.random());
  // Return the first `count` elements
  return shuffled.slice(0, count);
}

// URL slug from a game/app name. This exact rule is the contract shared with
// the PHP layer (prerender.php / sitemap.php) — both sides must produce the
// same slug so routes resolve. Keep them in sync.
export function slugify(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
